<div class="dp-reorder-grid" #grid cdkDropList cdkDropListSortingDisabled (cdkDropListDropped)="onDropped()">
    <div
        class="dp-item"
        *ngFor="let control of formArray?.controls; let i = index; trackBy: trackByControl"
        cdkDrag
        (cdkDragStarted)="onDragStarted(i, $event)"
        (cdkDragMoved)="onDragMoved($event)"
        [ngClass]="itemClassFn ? itemClassFn(control) : null"
    >
        <span class="dp-num" [attr.data-pos]="i + 1"></span>
        <span class="dp-reorder-content" cdkDragHandle>
            <ng-container *ngTemplateOutlet="itemTemplate; context: { $implicit: control, index: i }"></ng-container>
        </span>
        <span class="dp-reorder-extras" *ngIf="extrasTemplate">
            <ng-container *ngTemplateOutlet="extrasTemplate; context: { $implicit: control, index: i }"></ng-container>
        </span>
        <div class="dp-arrows">
            <button type="button" class="dp-arrow" matTooltip="Move up" [disabled]="i === 0" (click)="move(i, i - 1)">
                <mat-icon class="material-symbols-outlined">keyboard_arrow_up</mat-icon>
            </button>
            <button type="button" class="dp-arrow" matTooltip="Move down" [disabled]="i === formArray.length - 1" (click)="move(i, i + 1)">
                <mat-icon class="material-symbols-outlined">keyboard_arrow_down</mat-icon>
            </button>
        </div>
        <button type="button" class="dp-remove" mat-icon-button matTooltip="Remove Item" *ngIf="remove.observers.length" (click)="remove.emit(i)">
            <mat-icon class="material-symbols-outlined">close</mat-icon>
        </button>
    </div>
</div>
